export function parseWidth(width, fallback) {
    switch (typeof width) {
        case 'string':
            return width;
        case 'number':
            return `${width}px`;
        case 'object':
            return `minmax(${parseWidth(width.min, 'max-content')}, ${parseWidth(width.max)})`;
        default:
            return fallback || '1fr';
    }
}
//# sourceMappingURL=parseWidth.js.map